export default function getSlugPart(shortUrl: string) {
  const url = new URL(shortUrl);
  return url.pathname.replace('/', '');
}
